export const menuAgentAdmin = [
    {
        name: 'Ajouter',
        key: 'add'
    },
    {
        name: 'Modifier',
        key: 'modify'
    }
];